import { render, staticRenderFns } from "./ReturnVariable.vue?vue&type=template&id=04624758&"
import script from "./ReturnVariable.vue?vue&type=script&lang=js&"
export * from "./ReturnVariable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports